import { render, staticRenderFns } from "./menu-form.vue?vue&type=template&id=4421d78b"
import script from "./menu-form.vue?vue&type=script&lang=js"
export * from "./menu-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4421d78b')) {
      api.createRecord('4421d78b', component.options)
    } else {
      api.reload('4421d78b', component.options)
    }
    module.hot.accept("./menu-form.vue?vue&type=template&id=4421d78b", function () {
      api.rerender('4421d78b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/appmenu/menu-form.vue"
export default component.exports